/**
 * useAdminMenuSource — query GET /api/admin/menu/source (ADR-0034).
 *
 * Paletka admin builder: 16 stałych system items z ADMIN_SYSTEM_ITEMS.
 * Brak `modules` / `customModules` (admin scope nie ma subskrypcji modułów).
 *
 * staleTime 5 min — lista admin system items jest immutable na poziomie kodu.
 */

import type { AdminMenuSourceResponse } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const ADMIN_MENU_SOURCE_QUERY_KEY = ['admin', 'menu', 'source'] as const;

export function useAdminMenuSource(opts?: { enabled?: boolean }) {
  return useQuery<AdminMenuSourceResponse>({
    queryKey: ADMIN_MENU_SOURCE_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<AdminMenuSourceResponse>('/admin/menu/source');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 5 * 60_000,
  });
}
